<template>

    <auth-layout title="خطا 404">

        <b-container fluid class="mt-3">
            <b-alert show>صفحه مورد نظر یافت نشد.</b-alert>

        </b-container>

    </auth-layout>
</template>

<script>
    import AuthLayout from "../layouts/AuthLayout";
    export default {
        name: "PageNotFound",
        components: {AuthLayout}
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/pages/PageNotFound.vue